import React from 'react';
import { clsx, multiply, createUseStyles } from '@pushpay/styles';
import { getColors } from './shared';
import Skeleton from '.';
const useStyles = createUseStyles(theme => {
  const {
    shimmerColor
  } = getColors(theme);
  return {
    root: {},
    section: {
      display: 'flex',
      marginBottom: '2em'
    },
    labels: {
      flex: '1 1 auto',
      marginRight: multiply(theme.SPACING.FIELD_PADDING_H, 2)
    },
    row: {
      height: '2.5em',
      alignItems: 'center',
      '&+&': {
        marginTop: theme.SPACING.FIELD_PADDING_V
      },
      '&:first-of-type $content': {
        backgroundColor: shimmerColor,
        '&:after': {
          animation: 'none'
        }
      }
    },
    content: {},
    inputs: {
      flex: 3,
      display: 'flex',
      flexDirection: 'column',
      marginTop: '2.5em'
    },
    input: {
      flex: '1 1 auto',
      backgroundColor: theme.colors['color-background-input-readonly'],
      borderRadius: theme.SHAPE.ROUNDED_CORNERS,
      marginTop: theme.SPACING.FIELD_SPACING_V
    }
  };
});
export const SkeletonForm = props => {
  const {
    sections,
    rows,
    classes: classesProp,
    className: classNameProp,
    'data-pp-at-target': targetId,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), Array(sections).fill(null).map((_section, index) => {
    const key = `section-${index}`;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: classes.section
    }, /*#__PURE__*/React.createElement(Skeleton, {
      classes: {
        root: classes.labels,
        row: classes.row,
        content: classes.content
      },
      rows: rows + 1,
      "data-pp-at-target": `${targetId}-skeleton-${index}`
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.inputs
    }, Array(rows).fill(null).map((_input, inputIndex) => {
      const inputKey = `input-${inputIndex}`;
      return /*#__PURE__*/React.createElement("div", {
        key: inputKey,
        className: classes.input
      });
    })));
  }));
};